import React, { PropsWithChildren } from 'react';
import LiquiditySummarySettings from '../settings/LiquiditySummarySettings';
import {
    GridChartView,
    createGridChartViewToggleButtons,
} from 'utils/components/ViewToggleButtons/ViewToggleButtons';
import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import SelectionStatus from 'portfolio/components/SelectionStatus';
import { useSelectIsAppModeNewportSingleWidget } from 'app/store/general/selectors';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import { useLiquiditySummaryConfigSlice } from 'widgets/liquiditySummary/store/configuration/configSlice';
import { GridExportButton } from '@instinet-analytics/semantic-ui-components';
import { GridApi } from '@instinet-analytics/semantic-ui-components';
import { liquidityStreamedDataSelectors } from 'widgets/liquiditySummary/store/data/streamSlice';
import { useWidgetEditedColumnNames } from 'grid/columnNames/hooks';

type LiquiditySummaryToolbarProps = PropsWithChildren<{
    haveData: boolean;
    gridApi?: GridApi;
}>;

export default function LiquiditySummaryToolbar(
    props: LiquiditySummaryToolbarProps
) {
    const { haveData, children, gridApi } = props;

    const { config, dispatchConfigChanged } = useLiquiditySummaryConfigSlice();

    const isAppModeNewportSingleWidget =
        useSelectIsAppModeNewportSingleWidget();
    const { portfolioSelectionRequirements } =
        useWidgetPortfolioSelectionStatus();

    const { useWidgetMessages } = liquidityStreamedDataSelectors;
    const messages = useWidgetMessages();
    const { editedColumnNames } = useWidgetEditedColumnNames();

    const onViewChanged = (view: GridChartView) => {
        dispatchConfigChanged({ view });
    };

    return (
        <div className="LiquiditySummaryToolbar panel-header">
            {children}
            <div className="toolbar">
                <SelectionStatus
                    widgetName="Liquidity Summary Widget"
                    selectionRequirements={portfolioSelectionRequirements}
                />
            </div>
            <WidgetToolbar
                collapsibleItems={createGridChartViewToggleButtons(
                    config.view,
                    onViewChanged
                )}
                messages={messages}
                settingsTriggerText={
                    config.view === 'chart'
                        ? 'Chart Configuration'
                        : 'Table Configuration'
                }
                settingsHeader="Liquidity Summary Settings"
                settingsBody={
                    isAppModeNewportSingleWidget ? (
                        <LiquiditySummarySettings />
                    ) : undefined
                }
                showEditLayout={haveData}
                fixedItems={
                    haveData && config.view === 'grid' ? (
                        <GridExportButton
                            csvFileName="Liquidity Summary"
                            gridApi={gridApi}
                            editedColumnNames={editedColumnNames}
                        />
                    ) : undefined
                }
            />
        </div>
    );
}
